<template>
  <div class="col-12">
    <!-- Selected task types with amounts and units -->
    <span class="span-title">
      {{ $t('contracts.task_type') }}
    </span>
    <div class="col-sm-12">
      <div v-if="selectedTaskTypes.length > 0">
        <div
          v-for="item in selectedTaskTypes"
          :key="item.id"
          class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 inline"
        >
          <div class="col-sm-12 task-type-container">
            <span class="sub-title">
              {{ item.task_type.name }}
            </span>
            <div class="container">
              <div class="row">
                <div
                  class="col-6 pe-1 text-light m-auto"
                  style="font-size: .9em"
                >
                  {{ $t('contracts.amount') }}
                </div>
                <div
                  class="col-6 text-light m-auto"
                  style="font-size: .9em"
                >
                  <label>{{ $t('contracts.unit') }}</label>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div
                  class="col-6"
                >
                  <input
                    :id="item.task_type + 'amount'"
                    v-model="item.amount"
                    type="text"
                    class="form-control form-control-sm"
                  >
                </div>
                <div
                  class="col-6"
                  style="padding-left: 0 !important"
                >
                  <select
                    :id="item.id + 'unit'"
                    v-model="item.unit"
                    class="form-select form-select-sm"
                  >
                    <option
                      :value="''"
                      disabled
                    >
                      {{ $t('contracts.unit') }}
                    </option>
                    <option
                      v-for="option in options"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="item.id === undefined"
              class="col-sm-12 pt-2"
            >
              <button
                class="btn btn-sm btn-danger"
                @click.stop="removeFromSelection(item.task_type)"
              >
                {{ $t('common.remove') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="col-sm-12 small-pad"
      >
        <span>
          {{ $t('contracts.no_selected_task_types') }}
        </span>
      </div>
    </div>
    <!-- Task type list -->
    <span class="span-title">
      {{ $t('contracts.select_task_type') }}
    </span>
    <div
      class="row col-sm-12 inspectable-container"
      style="margin-left: 0 !important"
    >
      <div
        v-for="item in taskTypes"
        :key="item.id"
        class="d-flex col-sm-6 col-md-4 col-lg-3 col-xl-2 inline inspectables"
        :class="{ 'inspectables-disabled' : isSelected(item.id) }"
        @click="addToSelection(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {units, workManagementHelper} from '../mixins/WorkManagementMixin'

export default {
    name: 'ContractTaskTypes',
    mixins: [workManagementHelper, restApi],
    props: {
        useDefault: {
            type: Boolean,
            default: true
        },
        modelValue: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    emits: ['update:modelValue'],
    data: function () {
        return {
            loading: false,
            defaultTaskTypesLoading: false,
            taskTypesLoading: false,
            taskTypes: [],
            selectedTaskTypes: this.modelValue,
            options: [
                {value: units.HOUR, text: this.getUnitText(units.HOUR)},
                {value: units.DAY, text: this.getUnitText(units.DAY)},
                {value: units.WEEK, text: this.getUnitText(units.WEEK)},
                {value: units.MONTH, text: this.getUnitText(units.MONTH)},
                {value: units.TONS, text: this.getUnitText(units.TONS)},
                {value: units.METERS, text: this.getUnitText(units.METERS)},
                {value: units.KILOMETERS, text: this.getUnitText(units.KILOMETERS)},
                {value: units.SQUARE_METERS, text: this.getUnitText(units.SQUARE_METERS)},
                {value: units.CUBIC_METERS, text: this.getUnitText(units.CUBIC_METERS)},
                {value: units.PCS, text: this.getUnitText(units.PCS)}
            ]
        }
    },

    watch: {
        selectedTaskTypes: {
            handler: function () {
                if (!this.defaultTaskTypesLoading) {
                    this.$emit('update:modelValue', this.selectedTaskTypes)
                }
            },
            deep: true
        },
        modelValue: function (val) {
            if (!this.defaultTaskTypesLoading && val !== this.selectedTaskTypes) {
                this.selectedTaskTypes = val
            }
        }

    },

    created: function () {
        this.fetchTaskTypes()
        if (this.useDefault) {
            this.fetchDefaultTaskTypes()
        }
    },

    methods: {
        fetchDefaultTaskTypes: function () {
            this.defaultTaskTypesLoading = true
            this.restFetch(this.defaultTaskTypeUrl, this.handleDefaultTaskTypes, () => {
                this.defaultTaskTypesLoading = false
            })
        },

        handleDefaultTaskTypes: function (results) {
            results.data.forEach(item => {
                const exists = this.selectedTaskTypes.some(s => s.task_type.id === item.id)
                if (!exists) {
                    this.selectedTaskTypes.push({ task_type: { id: item.id, name: item.name }, amount: 0, unit: '' })
                }
            })
            this.defaultTaskTypesLoading = false
            this.$emit('update:modelValue', this.selectedTaskTypes)
        },


        fetchTaskTypes: function () {
            this.taskTypesLoading = true
            this.loading = true
            this.restFetch(this.taskTypeUrl, this.handleTaskTypes, this.onTaskTypeLoaded)
        },

        handleTaskTypes: function (response) {
            this.taskTypes = response.data
            this.onTaskTypeLoaded()
        },

        onTaskTypeLoaded: function () {
            this.taskTypesLoading = false
            this.loading = this.taskTypesLoading
        },

        indexOfTaskType: function (id) {
            return this.selectedTaskTypes.findIndex(function (obj) {
                return obj.task_type.id === id
            })
        },

        isSelected: function (id) {
            let index = this.indexOfTaskType(id)
            return index >= 0
        },

        addToSelection(item) {
            let index = this.selectedTaskTypes.findIndex(selectedItem => selectedItem.task_type.id === item.id)
            if (index < 0) {
                this.selectedTaskTypes.push({
                    'task_type': {'id': item.id, 'name': item.name},
                    'amount': 0,
                    'unit': ''
                })
            }
        },
        removeFromSelection (item) {
            let index = this.indexOfTaskType(item.id)
            if (index >= 0) {
                this.selectedTaskTypes.splice(index, 1)
            }
        },

    }
}
</script>
